import BaseInputText from "@/components/base-components/BaseInputText.vue";
import BaseSelectChoiceList from "@/components/base-components/BaseSelectChoiceList.vue";
import BaseInputCheckbox from "@/components/base-components/BaseInputCheckbox.vue";
import BaseCard from "@/components/base-components/BaseCard.vue";

export default function useGlobalComponents(app) {
  app.component("BaseInputText", BaseInputText);
  app.component("BaseInputCheckbox", BaseInputCheckbox);
  app.component("BaseCard", BaseCard);
  app.component("BaseSelectChoiceList", BaseSelectChoiceList);
}
